import React from 'react';
import { TextCTA } from './TextCTA';

const defaultLinks = [
  { label: 'Explore the category', href: '/the-category' },
  { label: 'Signal builder alignment', href: 'mailto:builders@coherenceos.com?subject=Builder%20Alignment' },
  { label: 'Signal investor alignment', href: 'mailto:investors@coherenceos.com?subject=Investor%20Alignment' },
];

export const ContinueExploring = ({ 
  links = defaultLinks,
  title = 'Continue exploring',
  className = '' 
}) => {
  return (
    <div className={`pt-8 border-t border-border ${className}`}>
      <p className="text-sm text-muted-foreground uppercase tracking-wider mb-4">
        {title}
      </p>
      <div className="flex flex-col gap-3">
        {links.map((link, index) => (
          <TextCTA 
            key={index} 
            href={link.href}
            external={link.href.startsWith('mailto:')}
          >
            {link.label}
          </TextCTA>
        ))}
      </div>
    </div>
  );
};

export default ContinueExploring;
